import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Bio } from './components/Bio';
import { Gallery } from './components/Gallery';
import { ExclusiveTease } from './components/ExclusiveTease';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="w-full min-h-screen bg-black" data-id="element-1">
        <Header data-id="element-2" />
        <Hero data-id="element-3" />
        <Bio data-id="element-4" />
        <Gallery data-id="element-5" />
        <ExclusiveTease data-id="element-6" />
        <Footer data-id="element-7" />
      </div>
    </LanguageProvider>;
}